import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Heart } from 'lucide-react';
import { salonInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <img 
              src="/posh-logo-dark.png" 
              alt="Posh Signature Beauty Salon" 
              className="h-16 w-auto mb-4 object-contain"
            />
            <p className="text-sm text-gray-400 mb-4">
              {salonInfo.tagline}
            </p>
            <p className="text-sm text-gray-400">
              Your exclusive women-only beauty sanctuary for premium salon experiences.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-amber-600 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-amber-600 transition-colors duration-200">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm hover:text-amber-600 transition-colors duration-200">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/offers" className="text-sm hover:text-amber-600 transition-colors duration-200">
                  Offers & New
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-sm hover:text-amber-600 transition-colors duration-200">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-amber-600 transition-colors duration-200">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-sm hover:text-amber-600 transition-colors duration-200">
                  Book Appointment
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-amber-600 mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-sm">{salonInfo.address}</span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 text-amber-600 mr-2 flex-shrink-0" />
                <div className="flex flex-col">
                  <a href={`tel:${salonInfo.phone}`} className="text-sm hover:text-amber-600 transition-colors duration-200">
                    {salonInfo.phone}
                  </a>
                  <a href={`tel:${salonInfo.alternatePhone}`} className="text-sm hover:text-amber-600 transition-colors duration-200">
                    {salonInfo.alternatePhone}
                  </a>
                </div>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 text-amber-600 mr-2 flex-shrink-0" />
                <a href={`mailto:${salonInfo.email}`} className="text-sm hover:text-amber-600 transition-colors duration-200">
                  {salonInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="text-white font-semibold mb-4">Opening Hours</h3>
            <ul className="space-y-2 mb-6">
              <li className="text-sm">
                <span className="text-gray-400">Monday:</span>
                <span className="ml-2 text-white">{salonInfo.hours.monday}</span>
              </li>
              <li className="text-sm">
                <span className="text-gray-400">Tue - Thu:</span>
                <span className="ml-2 text-white">{salonInfo.hours.tuesday}</span>
              </li>
              <li className="text-sm">
                <span className="text-gray-400">Friday:</span>
                <span className="ml-2 text-white">{salonInfo.hours.friday}</span>
              </li>
              <li className="text-sm">
                <span className="text-gray-400">Sat - Sun:</span>
                <span className="ml-2 text-white">{salonInfo.hours.saturday}</span>
              </li>
            </ul>
            <div className="flex space-x-4">
              <a
                href={salonInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-gray-800 rounded-full hover:bg-amber-600 transition-all duration-200"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400 flex items-center justify-center">
            © 2025 Posh Signature Beauty Salon. All rights reserved. Made with{' '}
            <Heart className="w-4 h-4 text-amber-600 mx-1 fill-current" /> for women.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
